import * as types from "../../actions/types/index";
import {setInitialState} from "../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
});
export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.CHANGE_MOBILE_NUMBER_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.CHANGE_MOBILE_NUMBER_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload.success
            };
        case types.CHANGE_MOBILE_NUMBER_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload.response.error,
            };
        case types.RESET_CHANGE_MOBILE_NUMBER:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}